import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { AccountService } from '@services/account.service'
import { AuthService } from '@services/auth.service'
import { AccountProductType } from '@models/account.model'
import { Router } from '@angular/router'
import { PlatformService } from '@services/platform.service'
import { environment } from '@envs/environment'

@Component({
	selector: 'sbpro-top-nav-user',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './top-nav-user.component.html',
	styleUrls: ['top-nav-user.component.scss'],
	standalone: false
})
export class TopNavUserComponent {
	@Input() profileEditable = true
	@Input() placement = 'bottom-end'

	protected readonly AccountProductType = AccountProductType
	/** No app a versão sai do rodapé e fica abaixo de Sair (spec 058). */
	readonly version = environment.version ?? '1.0.0'

	constructor(
		private router: Router,
		public authService: AuthService,
		public platform: PlatformService,
		public accountService: AccountService
	) {}

	changeToSupplier() {
		this.accountService.clearStoreAccount()
		this.accountService.changeProduct(AccountProductType.SUP)
	}

	changeToSigner() {
		this.accountService.clearStoreAccount()
		this.accountService.changeProduct(AccountProductType.SIG)
	}

	/** Área do visitante (spec 048): sem órgão, como a do fornecedor. */
	changeToVisitor() {
		this.accountService.clearStoreAccount()
		this.accountService.syncRoleProducts()
		this.accountService.changeProduct(AccountProductType.VIS)
	}

	goVisitorActivation() {
		this.router.navigate(['/auth/visitor-activation']).then()
	}

	/** "Minha Conta" do visitante é Meus dados; ele não tem conta de órgão. */
	get accountLink() {
		return this.accountService.currentProductVisitor ? '/visitor/profile' : '/account/profile/detail'
	}

	/** Ativação do perfil de visitante (RF 6): quem pode ativar, fora do app móvel. */
	get showVisitorActivation() {
		return this.accountService.canActivateVisitor && !this.platform.mobile
	}

	goRoleSelect() {
		this.accountService.clearStoreAccount()
		this.router.navigate(['/auth/role-select']).then()
	}

	get hasDualRole() {
		const roles = [this.accountService.isSupplier, this.accountService.isSinger, this.accountService.isAppMember, this.accountService.isVisitor]

		return roles.filter(Boolean).length >= 2
	}

	get isSupplierBoard() {
		return this.accountService.isSupplier && !window.location.pathname.includes('/supplier/board')
	}

	get isSignerBoard() {
		return this.accountService.isSinger && !window.location.pathname.includes('/signer/board')
	}

	userInitials(name?: string) {
		if (!name) {
			return '??'
		}

		const parts = name.trim().split(/\s+/).filter(Boolean)

		if (parts.length === 0) {
			return '??'
		}

		if (parts.length === 1) {
			return parts[0].slice(0, 2).toUpperCase()
		}

		const initials = `${parts[0][0]}${parts[1][0]}`
		return initials.toUpperCase()
	}
}
